import mainService from "./mainService";
const path = "admin/course";

export function list() {
    return mainService
        .get(path + "/list/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function search(query, page = 1) {
    return mainService
        .post(path + "/search/", {
            pagination: { page: page, perpage: 30 },
            query: query
        })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function searchLesson(query, cid, page = 1) {
    return mainService
        .post(path + "/searchLesson/", {
            pagination: { page: page, perpage: 30 },
            query: query,
            cid: cid
        })
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function createCourse(data) {    
    return mainService
        .post(path + "/create/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function remove(id) {
    return mainService
        .delete(path + "/delete/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function record(id) {
    return mainService
        .get(path + "/record/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function update(id, data) {
    return mainService
        .post(path + "/update/" + id, data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function recordLesson(id) {
    return mainService
        .get(path + "/lessons/record/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function updateLesson(id, data) {
    return mainService
        .post(path + "/lessons/update/" + id, data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


export function createLession(data) {    
    return mainService
        .post(path + "/lessons/create/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function listLession(id) {    
    return mainService
        .get(path + "/lessons/"+ id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function listLessionRecord(id) {    
    return mainService
        .get(path + "/lessons/record/"+ id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function removeLession(id)
{
    return mainService
        .delete(path + "/lessons/delete/" + id)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
export function createCourseCategory(data)
{
    return mainService
        .post("admin/category/create/", data)
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}

export function catList() {
    return mainService
        .get(path + "/catlist/")
        .then(res => {
            return res.data;
        })
        .catch(error => {
            return Promise.reject(error);
        });
}


// WEBPACK FOOTER //
// ./src/services/course.jsx